var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hbp-container hbp-container-above" }, [
    _c("div", { staticClass: "announcement router-view" }, [
      _c("div", { staticClass: "announcement-panel" }, [
        _c("div", { staticClass: "announcement-detail" }, [
          _c("div", {
            staticClass: "detail-html",
            domProps: { innerHTML: _vm._s(_vm.content) }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-602fcde8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-602fcde8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/updataSafetyInfo/updateSafetyDetail.vue
// module id = null
// module chunks = 